module.exports = __webpack_public_path__ + "static/img/guonei_bg.660752a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guonei_bg.png
// module id = 93rs
// module chunks = 27